/*
 * @Author: ryyyyy
 * @Date: 2022-03-01 16:12:41
 * @LastEditors: ryyyyy
 * @LastEditTime: 2022-03-01 17:55:26
 * @FilePath: /create-data-app/src/index.jsx
 * @Description:
 *
 * Copyright (c) 2022 by 用户/公司名, All Rights Reserved.
 */

import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
import 'babel-polyfill'
import "core-js"

import "./theme.variable.less"; // 可变主题色
// import './theme.less'; // 固定主题色
import "./index.scss";
import "./antdIndex.scss";
import ReactDOM from "react-dom";
import React from "react";
import { HashRouter } from "react-router-dom";
import Error from "@/pages/error";
import Layout from "@/pages/layout";
import { ConfigProvider, Select } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import GlobalState from "@/global";
import * as dayjs from "dayjs";
// import { registerSentry } from "@/utils/sentry-register";
import { PAGE_CONTAINER_ID } from "@/utils/constant";

require("dayjs/locale/zh-cn");
dayjs.locale("zh-cn");

// if (process.env.MODE && process.env.MODE !== 'development') {
//   registerSentry({
//     dsn: process.env.SENTRY_DNS,
//     captureResource: true,
//     captureXhr: true,
//   });
// }

function defaultGetContainer() {
  return document.getElementById(PAGE_CONTAINER_ID);
}

//render
ReactDOM.render(
  <Error>
    <HashRouter>
      <ConfigProvider locale={zhCN}>
        <GlobalState.Provider>
          <Layout />
        </GlobalState.Provider>
      </ConfigProvider>
    </HashRouter>
  </Error>,
  document.getElementById("page-container")
);